export default [
    {
        id: 1,
        name_ca: 'Obra nova',
        name_en: 'New construction',
        name_es: 'Obra nueva'
    },
    {
        id: 2,
        name_ca: 'Rehabilitació',
        name_en: 'Renovation',
        name_es: 'Rehabilitación'
    },
]



// WEBPACK FOOTER //
// ./src/options/project_types.js